<div class="theme-toggle-wrapper">

    <button class="icon-btn light-icon" [class.active]="!isDark()" (click)="setTheme('light')"
        aria-label="Enable Light Mode">
        <mat-icon>light_mode</mat-icon>
    </button>

    <div class="custom-switch" (click)="toggle()" [class.checked]="isDark()" role="switch"
        [attr.aria-checked]="isDark()" tabindex="0" (keydown.enter)="toggle()" (keydown.space)="toggle()">
        <div class="switch-track"></div>
        <div class="switch-thumb"></div>
    </div>

    <!-- Right Icon: Dark Mode -->
    <!-- Clickable label that forces Dark Mode -->
    <button class="icon-btn dark-icon" [class.active]="isDark()" (click)="setTheme('dark')"
        aria-label="Enable Dark Mode">
        <mat-icon>dark_mode</mat-icon>
    </button>

</div>